(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-sku"] && !Shopify.designMode) return;
  try {
    // Custom element for dynamic SKU updates - follows theme's pattern
  class ProductSku extends HTMLElement {
    connectedCallback() {
      const closestSection = this.closest('.shopify-section, dialog');
      
      if (!closestSection) {
        document.addEventListener('variant:update', this.updateSku);
        return;
      }
      
      // Listen for variant updates at section level (same as product-price.js)
      closestSection.addEventListener('variant:update', this.updateSku);
    }

    disconnectedCallback() {
      const closestSection = this.closest('.shopify-section, dialog');
      if (closestSection) {
        closestSection.removeEventListener('variant:update', this.updateSku);
      } else {
        document.removeEventListener('variant:update', this.updateSku);
      }
    }

    updateSku = (event) => {
      // Check if this update is for the correct product
      if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
        return;
      }

      // Get the variant data directly from the event
      const variant = event.detail.resource;
      
      if (variant && variant.sku) {
        const currentSkuElement = this.querySelector('.sku-value');
        if (currentSkuElement) {
          currentSkuElement.textContent = variant.sku;
        }
      }
    };
  }

  // Register the custom element
  if (!customElements.get('product-sku')) {
    customElements.define('product-sku', ProductSku);
  }

  // Fallback: also listen for variant changes directly
  document.addEventListener('DOMContentLoaded', function() {
    // Listen for any variant-related changes
    document.addEventListener('variant:update', function(event) {
      const variant = event.detail.resource;
      
      if (variant && variant.sku) {
        const skuElements = document.querySelectorAll('[data-product-sku] .sku-value');
        skuElements.forEach(skuElement => {
          skuElement.textContent = variant.sku;
        });
      }
    });
    
    // Listen for variant selection
    document.addEventListener('variant:selected', function(event) {
      const variant = event.detail.resource;
      if (variant && variant.sku) {
        const skuElements = document.querySelectorAll('[data-product-sku] .sku-value');
        skuElements.forEach(skuElement => {
          skuElement.textContent = variant.sku;
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
